export default {"src":"/_next/static/media/filters.9e523859.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};